'use strict';

exports.__esModule = true;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.kea = kea;

var _props = require('./connect/props');

var _propTypes = require('./connect/prop-types');

var _reducer = require('./logic/reducer');

var _selectors = require('./logic/selectors');

var _create = require('./actions/create');

var _actions = require('./connect/actions');

var _convertConstants = require('../utils/convert-constants');

var _convertConstants2 = _interopRequireDefault(_convertConstants);

var _shallowEqual = require('../utils/shallow-equal');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _reselect = require('reselect');

var _reactRedux = require('react-redux');

var _cache = require('./cache');

var _reducer2 = require('./reducer');

var _plugins = require('./plugins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEBUG = false;

var nonameCounter = 0;

function isStateless(Component) {
  return !Component.prototype.render;
}

var hydrationAction = '@@kea/hydrate store';

function kea(input) {
  var hasConnect = !!input.connect;
  var hasLogic = !!(input.path || input.actions || input.reducers || input.selectors);
  var isSingleton = !input.key;

  var output = {};

  // check which plugins are active
  output.activePlugins = [];
  _plugins.installedPlugins.forEach(function (plugin) {
    output.activePlugins[plugin.name] = plugin.isActive(input, output);
  });

  if (!input.path) {
    var reducerRoot = (0, _reducer2.firstReducerRoot)();
    if (!reducerRoot) {
      console.error('[KEA] Could not find the root of the keaReducer! Make sure you call keaReducer() before any call to kea() is made. See: https://kea.js.org/api/reducer');
    }
    var inlinePath = [reducerRoot, '_kea', 'inline-' + nonameCounter++];
    input.path = function () {
      return inlinePath;
    };
  }

  var propTypes = {};
  var connect = {};

  if (hasConnect) {
    // the { connect: { props, actions } } part
    connect = input.connect || {};

    // get default proptypes and add connected ones
    propTypes = (0, _assign2.default)({}, connect.props ? (0, _propTypes.propTypesFromMapping)(connect) : {});

    // connected actions and props/selectors
    output.connected = {
      actions: (0, _actions.selectActionsFromLogic)(connect.actions),
      selectors: (0, _props.selectPropsFromLogic)(connect.props)
    };

    if (isSingleton) {
      output.actions = (0, _assign2.default)({}, output.connected.actions);
      output.selectors = (0, _assign2.default)({}, output.connected.selectors);
    }

    _plugins.installedPlugins.forEach(function (plugin) {
      plugin.afterConnect && plugin.afterConnect(output.activePlugins[plugin.name], input, output);
    });
  }

  // pregenerate as many things as we can
  output.constants = input.constants ? (0, _convertConstants2.default)(input.constants(output)) : {};

  if (hasLogic) {
    // we don't know yet if it's going to be a singleton (no key) or inline (key)
    // however the actions and constants are common for all, so get a path without the dynamic
    // component and initialize them
    output.path = input.path('').filter(function (p) {
      return p;
    });
    output.actions = (0, _assign2.default)({}, output.actions, input.actions ? (0, _create.createActions)(input.actions(output), output.path) : {});
    output.props = {};

    _plugins.installedPlugins.forEach(function (plugin) {
      plugin.afterCreateActions && plugin.afterCreateActions(output.activePlugins[plugin.name], input, output);
    });
  }

  if (hasLogic && isSingleton) {
    output.selector = function (state) {
      return (0, _selectors.pathSelector)(output.path, state);
    };
    output.reducers = input.reducers ? (0, _reducer.convertReducerArrays)(input.reducers(output)) : {};
    output.reducer = input.reducer ? input.reducer(output) : (0, _reducer.combineReducerObjects)(output.path, output.reducers);
    output.selectors = (0, _assign2.default)({}, output.selectors, (0, _selectors.createSelectors)(output.path, (0, _keys2.default)(output.reducers || {})));

    var selectorResponse = input.selectors ? input.selectors(output) : {};
    (0, _keys2.default)(selectorResponse).forEach(function (selectorKey) {
      // s == [() => args, selectorFunction, propType]
      var s = selectorResponse[selectorKey];
      var args = s[0]();
      if (s[2]) {
        output.reducers[selectorKey] = { type: s[2] };
      }
      output.selectors[selectorKey] = _reselect.createSelector.apply(undefined, args.concat([s[1]]));
    });

    _plugins.installedPlugins.forEach(function (plugin) {
      plugin.afterAddSingletonLogic && plugin.afterAddSingletonLogic(output.activePlugins[plugin.name], input, output);
    });
  }

  if (isSingleton) {
    _plugins.installedPlugins.forEach(function (plugin) {
      plugin.afterCreateSingleton && plugin.afterCreateSingleton(output.activePlugins[plugin.name], input, output);
    });
  }

  var response = function response(Klass) {
    // initializing as a singleton
    if (Klass === false) {
      if (!isSingleton) {
        console.error('[KEA-LOGIC] Standalone "export default kea({})" functions must have no "key"!', output.path, Klass);
      }

      return (0, _assign2.default)(input, output);
    }

    if (Klass && Klass.propTypes) {
      propTypes = (0, _assign2.default)({}, propTypes, Klass.propTypes);
    }

    if (hasLogic) {
      // add proptypes from reducer
      var reducers = input.reducers ? (0, _reducer.convertReducerArrays)(input.reducers(output)) : {};
      (0, _keys2.default)(reducers).forEach(function (reducerKey) {
        if (reducers[reducerKey].type) {
          propTypes[reducerKey] = reducers[reducerKey].type;
        }
      });

      // add proptypes from selectors
      var selectorsThatDontWork = input.selectors ? input.selectors({}) : {};
      (0, _keys2.default)(selectorsThatDontWork).forEach(function (selectorKey) {
        if (selectorsThatDontWork[selectorKey][2]) {
          propTypes[selectorKey] = selectorsThatDontWork[selectorKey][2];
        }
      });
    }

    if (Klass) {
      Klass.propTypes = (0, _assign2.default)({}, propTypes, Klass.propTypes || {});
    }

    if (Klass && hasLogic) {
      // add kea metadata to component
      Klass.kea = {
        path: input.path,
        constants: output.constants,
        actions: output.actions,
        select: function select(key) {
          return (0, _cache.getCache)(input.path(key), 'selectors');
        }
      };
    }

    if (Klass && (hasLogic || hasConnect)) {
      // convert this.props.actions to this.actions in the component
      var originalComponentWillMount = Klass.prototype.componentWillMount;
      Klass.prototype.componentWillMount = function () {
        this.actions = this.props.actions;
        originalComponentWillMount && originalComponentWillMount.bind(this)();
      };
    }

    // If we're wrapping a functional React component, skip adding plugins.
    // This requires lifecycle methods like componentWillMount, etc, which functional components don't have.
    // We'll instead add plugins to Redux's Connected class.
    if (Klass && !isStateless(Klass)) {
      _plugins.installedPlugins.forEach(function (plugin) {
        plugin.injectToClass && plugin.injectToClass(output.activePlugins[plugin.name], input, output, Klass);
      });
    }

    var selectorFactory = function selectorFactory(dispatch, options) {
      var lastProps = {};
      var result = null;

      if (!(0, _reducer2.isSyncedWithStore)()) {
        dispatch({ type: hydrationAction });
      }

      return function (nextState, nextOwnProps) {
        var key = void 0;
        var path = void 0;
        var joinedPath = void 0;

        var nextProps = (0, _assign2.default)({}, nextOwnProps);

        if (hasConnect) {
          // TODO: this will fail if the redux tree is not initialized yet.
          // see comment in logic-component.js

          // connected props
          (0, _keys2.default)(output.connected.selectors).forEach(function (propKey) {
            nextProps[propKey] = output.connected.selectors[propKey](nextState, nextOwnProps);
          });
        }

        if (hasLogic) {
          key = input.key ? input.key(nextOwnProps) : null;

          if (typeof key === 'undefined') {
            console.error('"key" can\'t be undefined in path: ' + input.path('undefined').join('.'));
          }

          path = input.path(key);
          joinedPath = path.join('.');

          if (DEBUG) {
            console.log('Inline selectorFactory for ' + joinedPath);
            console.log({ nextOwnProps: nextOwnProps, nextState: nextState, key: key, path: path });
          }

          var selector = void 0;
          var selectors = void 0;

          // now we must check if the reducer is already in redux, or we need to add it
          // if we need to add it, create "dummy" selectors for the default values until then

          // is the reducer created? if we have "true" in the cache, it's definitely created
          var reducerCreated = !!(0, _cache.getCache)(joinedPath, 'reducerCreated');

          // if it's not let's double check. maybe it is now?
          if (!reducerCreated) {
            try {
              selector = function selector(state) {
                return (0, _selectors.pathSelector)(path, state);
              };
              reducerCreated = typeof selector(nextState) !== 'undefined';
            } catch (e) {
              reducerCreated = false;
            }
          }

          // we have the selectors cached! with the current reducerCreated state!
          if (!!(0, _cache.getCache)(joinedPath, reducerCreated) === reducerCreated) {
            if (DEBUG) {
              console.log('cache hit!');
            }
            selector = (0, _cache.getCache)(joinedPath, 'selector');
            selectors = (0, _cache.getCache)(joinedPath, 'selectors');

            // either we have nothing cached or the cache is invalid. regenerate the selectors!
          } else {
            if (!selector) {
              selector = function selector(state) {
                return (0, _selectors.pathSelector)(path, state);
              };
            }

            // add { path } and { key } to the reducer creator function
            var localObject = (0, _assign2.default)({}, output, { path: path, key: key, props: nextOwnProps });
            localObject.reducers = input.reducers ? (0, _reducer.convertReducerArrays)(input.reducers(localObject)) : {};
            localObject.reducer = input.reducer ? input.reducer(localObject) : (0, _reducer.combineReducerObjects)(path, localObject.reducers);

            var connectedSelectors = output.connected ? output.connected.selectors : {};

            // if the reducer is in redux, get real reducer selectors. otherwise add dummies that return defaults
            if (reducerCreated) {
              selectors = (0, _assign2.default)({}, connectedSelectors || {}, (0, _selectors.createSelectors)(path, (0, _keys2.default)(localObject.reducers)));
            } else {
              (0, _reducer2.addReducer)(path, localObject.reducer, true);
              if (!(0, _reducer2.isSyncedWithStore)()) {
                dispatch({ type: hydrationAction });
              }

              var realSelectors = (0, _selectors.createSelectors)(path, (0, _keys2.default)(localObject.reducers));

              // if we don't know for sure that the reducer is in the current store output,
              // then fallback to giving the default value
              selectors = (0, _assign2.default)({}, connectedSelectors || {});
              (0, _keys2.default)(localObject.reducers).forEach(function (key) {
                selectors[key] = function (state) {
                  try {
                    return realSelectors[key](state);
                  } catch (error) {
                    return localObject.reducers[key].value;
                  }
                };
              });
            }

            // create
            var _selectorResponse = input.selectors ? input.selectors((0, _assign2.default)({}, localObject, { selectors: selectors })) : {};

            (0, _keys2.default)(_selectorResponse).forEach(function (selectorKey) {
              // s == [() => args, selectorFunction, propType]
              var s = _selectorResponse[selectorKey];

              var args = s[0]();
              selectors[selectorKey] = _reselect.createSelector.apply(undefined, args.concat([s[1]]));
            });

            // store in the cache
            (0, _cache.setCache)(joinedPath, {
              reducerCreated: reducerCreated,
              selector: selector,
              selectors: selectors
            });
          }

          if (DEBUG) {
            console.log({ selector: selector, selectors: selectors });
          }

          (0, _keys2.default)(selectors).forEach(function (selectorKey) {
            nextProps[selectorKey] = selectors[selectorKey](nextState, nextOwnProps);
          });
        }

        if (DEBUG) {
          console.log({ nextProps: nextProps });
        }

        // TODO: cache these even if no path present
        var actions = joinedPath ? (0, _cache.getCache)(joinedPath, 'actions') : null;

        if (!actions) {
          actions = {};

          if (hasConnect) {
            // pass conneted actions as they are
            (0, _keys2.default)(output.connected.actions).forEach(function (actionKey) {
              actions[actionKey] = function () {
                var _output$connected$act;

                return dispatch((_output$connected$act = output.connected.actions)[actionKey].apply(_output$connected$act, arguments));
              };
            });
          }

          if (hasLogic) {
            // inject key to the payload of inline actions
            (0, _keys2.default)(output.actions).forEach(function (actionKey) {
              if (key) {
                actions[actionKey] = function () {
                  var _output$actions;

                  var createdAction = (_output$actions = output.actions)[actionKey].apply(_output$actions, arguments);

                  // an object! add the key and dispatch
                  if ((typeof createdAction === 'undefined' ? 'undefined' : (0, _typeof3.default)(createdAction)) === 'object') {
                    return dispatch((0, _assign2.default)({}, createdAction, { payload: (0, _assign2.default)({ key: key }, createdAction.payload) }));
                  } else {
                    // a function? a string? return it!
                    return dispatch(createdAction);
                  }
                };
              } else {
                actions[actionKey] = function () {
                  var _output$actions2;

                  return dispatch((_output$actions2 = output.actions)[actionKey].apply(_output$actions2, arguments));
                };
              }
            });
          }

          if (DEBUG) {
            console.log({ actions: actions });
          }

          if (joinedPath) {
            (0, _cache.setCache)(joinedPath, { actions: actions });
          }
        }

        // if the props did not change, return the old cached output
        if (!result || !(0, _shallowEqual2.default)(lastProps, nextProps)) {
          lastProps = nextProps;
          result = (0, _assign2.default)({}, nextProps, { actions: actions, dispatch: dispatch });
        }

        return result;
      };
    };

    var KonnektedKlass = (0, _reactRedux.connectAdvanced)(selectorFactory, { methodName: 'kea' })(Klass);

    // If we were wrapping a functional React component, add the plugin code to the connected component.
    if (Klass && isStateless(Klass)) {
      _plugins.installedPlugins.forEach(function (plugin) {
        plugin.injectToConnectedClass && plugin.injectToConnectedClass(output.activePlugins[plugin.name], input, output, KonnektedKlass);
      });
    }

    return KonnektedKlass;
  };

  response.path = output.path;
  response.constants = output.constants;
  response.actions = output.actions;
  response.reducer = output.reducer;
  response.reducers = output.reducers;
  response.selector = output.selector;
  response.selectors = output.selectors;

  response._isKeaFunction = true;
  response._isKeaSingleton = isSingleton;
  response._hasKeaConnect = hasConnect;
  response._hasKeaLogic = hasLogic;
  response._keaPlugins = output.activePlugins;

  _plugins.installedPlugins.forEach(function (plugin) {
    plugin.addToResponse && plugin.addToResponse(output.activePlugins[plugin.name], input, output, response);
  });

  if (output.path) {
    if (isSingleton) {
      (0, _reducer2.addReducer)(output.path, output.reducer, true);
      response._keaReducerConnected = true;
    } else {
      response._keaReducerConnected = false;
    }
  }

  return response;
}


//////////////////
// WEBPACK FOOTER
// ./~/kea/es/kea/index.js
// module id = 825
// module chunks = 2